import domain from '@framework/config/domain';
import env from '@framework/env/env';

const config = {
  name: 'Deal Manager Portal',
  code: 'dmPortal' as const,
  supportEmail: env('CREDENTIALS__DM_PORTAL__SUPPORT__EMAIL'),
  hostname: `${ domain.managerDomain }`,
  ga: {
    trackingId: env('GA__TRACKING_ID_DEALROADSHOW'),
  },
  gtm: {
    trackingId: env('FRONTEND___GOOGLE_TAG_MANAGER__TENANT_DEALROADSHOW__GTM_ID'),
  },
  supportChatId: env('FRONT_APP__CHAT_ID_TENANT_DM_PORTAL'),
  api: {
    internal: env('DM_PORTAL_WS__HOSTNAME_INTERNAL'),
    noteInternal: env('NOTE_WS__HOSTNAME_INTERNAL'),
    investorTargetingInternal: env('INVESTOR_TARGETING_WS__HOSTNAME_INTERNAL'),
    requestMeetingInternal: env('REQUEST_MEETING_WS__HOSTNAME_INTERNAL'),
    openMarketInternal: env('OPENMARKET_WS__HOSTNAME_INTERNAL'),
    orderBookInternal: env('DM_PORTAL_WS__HOSTNAME_INTERNAL'),
  },
  featureToggle: {
    requestsSummary: { cookieName: 'requestsSummary' },
    evercallRegistrationLimit: { cookieName: 'evercallRegistrationLimit' },
    transcriptions: { cookieName: 'transcriptions' },
    documentTranslationEnabled: { cookieName: 'documentTranslationEnabled' },
    ocrEnabled: { cookieName: 'ocrEnabled' },
    evercallPublishFlow: { cookieName: 'evercallPublishFlow' },
    accountFilterActivity: { cookieName: 'accountFilterActivity' },
  },
};

export default config;
